// extracted by mini-css-extract-plugin
module.exports = {"container":"CataloguePagination_container__p_xCa","selected":"CataloguePagination_selected__J7RBD","unselected":"CataloguePagination_unselected__r_7EH"};